module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/loading-page/loading-page.component.scss
// module id = ./src/app/components/loading-page/loading-page.component.scss
// module chunks = main